"use client";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";
import { logError } from "./../logging/logger";
import meltingChip from "./meltingchip.svg";

type ErrorProps = {
  error: Error;
};

export default function ErrorPage({ error }: ErrorProps) {
  useEffect(() => {
    logError(error);
  }, [error]);

  return (
    <div className="h-screen flex flex-col items-center">
      <div className="flex flex-col items-center px-4 max-w-900 grow w-full">
        <div className="grow max-w w-full flex flex-col">
          <div className="flex flex-col h-full justify-center">
            <div className="grow flex flex-col items-center justify-center mb-4">
              <Image
                src={meltingChip}
                alt="melting chip"
                className="w-120 h-120 pb-6"
              />
              <h1 className="pb-3 text-2xl font-montserrat font-semibold">
                We had an issue
              </h1>
              <p className="pb-1 text-sm font-inter text-center w-1/2">
                Please wait a moment and try again. For more information, check{" "}
                <Link
                  href="https://status.groq.com"
                  className="text-primaryaccent"
                >
                  Groq Status
                </Link>
                .
              </p>
              <p className="pb-7 font-mono text-xs text-center">
                Error: {JSON.stringify(error?.message)}
              </p>
              <div className="flex items-center justify-center gap-4">
                <Link
                  href="/dashboard"
                  className={cn(buttonVariants({ variant: "outline" }))}
                >
                  Return to Dashboard
                </Link>
                <Link
                  href={window.location.href}
                  className={cn(
                    buttonVariants({ variant: "default" }),
                    "min-w-40",
                  )}
                >
                  Retry
                </Link>
              </div>
              <p className="hidden text-xs font-inter text-center">
                &copy;{new Date().getFullYear()} Groq, Inc. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
